export default "__VITE_ASSET__D7nIINee__"